import { render, staticRenderFns } from "./ReferralsPatientDetailsModal.vue?vue&type=template&id=cd1f71fc&scoped=true"
import script from "./ReferralsPatientDetailsModal.vue?vue&type=script&lang=js"
export * from "./ReferralsPatientDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./ReferralsPatientDetailsModal.vue?vue&type=style&index=0&id=cd1f71fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd1f71fc",
  null
  
)

export default component.exports